import styled from "styled-components";

export const StatusChartWrapper = styled.div`
  width: 100%;
  height: fit-content;
  padding: 24px;
  border-bottom: 1px solid var(--border-emphasis);
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const InsightStatement = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const CountContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const Label = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--hv-text-normal-secondary);
`;

export const Count = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const chartContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  flex-direction: row;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ColorBox = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 25px;
  color: ${(props) => props.color};
  background-color: ${(props) => props.color};
`;

export const LegendLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--hv-text-normal-secondary);
`;

export const LegendCount = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--hv-text-normal-secondary);
`;

export const ChartTable = styled.div`
  flex: 1;
`;

export const Text = styled.span<{ secondary?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0%;

  color: ${(props) =>
    props.secondary
      ? "var(--hv-text-normal-secondary)"
      : "var(--hv-text-normal-primary)"};
`;
